export const ROLES = {
    SUPER_ADMIN: 'Super Admin',
    ADMIN: 'admin',
    PHOTOGRAPHER: '',
};
export const ROLE_IDS = {
    SUPER_ADMIN: 1,
    ADMIN: 2,
    PHOTOGRAPHER: 3,
};